import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from 'react-query'
import { Toaster } from 'react-hot-toast'
import App from './App.tsx'
import { AuthProvider } from './contexts/AuthContext.tsx'
import '../global.css'

// Create React Query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 3,
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
    },
    mutations: {
      retry: 1,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <App />
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: 'var(--color-tertiarySystemBackground)',
                color: 'var(--color-label)',
                border: '1px solid var(--color-separator)',
                borderRadius: 'var(--border-radius-lg)',
                boxShadow: 'var(--shadow-modal)',
                fontFamily: 'var(--font-family-appleSystem)',
                fontSize: 'var(--font-size-base)',
              },
              success: {
                duration: 3000,
                iconTheme: {
                  primary: 'var(--color-success)',
                  secondary: 'var(--color-systemBackground)',
                },
              },
              error: {
                duration: 5000,
                iconTheme: {
                  primary: 'var(--color-error)',
                  secondary: 'var(--color-systemBackground)',
                },
              },
            }}
          />
        </AuthProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>,
) 